"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommonErrors;
(function (CommonErrors) {
    CommonErrors["TaxIdUpdateFailed"] = "COMMON__TAX_ID_UPDATE_FAILED";
})(CommonErrors || (CommonErrors = {}));
exports.default = CommonErrors;
